import { ThirdPartyConsentStatusEnum } from '@secca/shared/models/enums';

export class CaseThirdPartyConsent {
  name: string;
  consentStatus: ThirdPartyConsentStatusEnum;
  disabled: boolean;
  legalGuardianSet: boolean;

  constructor(name: string,
              consentStatus: ThirdPartyConsentStatusEnum,
              legalGuardianSet?: boolean) {
    this.name = name;
    this.consentStatus = consentStatus;
    this.legalGuardianSet = legalGuardianSet;
    this.disabled = !legalGuardianSet;
  }
}
